// action
import {
    SAVE_ARTICLE,
    SAVE_ARTICLE_FAIL,
    SAVE_ARTICLE_SUCCESS,
    SAVE_ARTICLE_RESET
} from '../action/saveArticleAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_ARTICLE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_ARTICLE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_ARTICLE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_ARTICLE_RESET:
            return initialState
        default:
            return state
    }
}